import {type FormEvent, useId} from 'react';
import {useIsPasswordInvalid} from '../../context/is-password-invalid';
import {LogoIcon} from '../icons';
import {useSetPreviewPagePassword} from '../../context/password';
import styles from './password-form.module.css';

export function PasswordForm() {
  const id = useId();
  const isPasswordInvalid = useIsPasswordInvalid();
  const setPreviewPagePassword = useSetPreviewPagePassword();

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (!(event.target instanceof HTMLFormElement)) return;

    const password = new FormData(event.target).get('password');
    if (typeof password !== 'string') return;

    setPreviewPagePassword(password);
  };

  return (
    <div>
      <header className={styles.header}>
        <LogoIcon />
      </header>

      <main className={styles.main}>
        <h1 id={`${id}-label`} className={styles.heading}>
          プレスリリース詳細プレビュー
        </h1>
        <p id={`${id}-description`} className={styles.description}>
          こちらのページを閲覧いただくにはパスワードをご入力ください。
        </p>
        <form
          aria-labelledby={`${id}-label`}
          aria-describedby={`${id}-description`}
          className={styles.form}
          onSubmit={onSubmit}
        >
          <input
            type='password'
            placeholder='パスワード'
            aria-label='パスワード'
            className={styles.input}
            name='password'
          />
          {isPasswordInvalid && (
            <p className={styles.errorText}>パスワードが正しくありません。</p>
          )}
          <button type='submit' className={styles.button}>
            閲覧する
          </button>
        </form>
      </main>
    </div>
  );
}
